import { useDesignMaxTheme } from "@/packages";
import { type RoomType } from "@/shared/server";
import { ImgGallery } from "../imgGallery";

export const RoomFeed = ({ room }: { room: RoomType }) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();

    const filteredImgList = room.imgList.slice(1, isMobile ? 4 : 7);
    return <ImgGallery imgList={filteredImgList} />;
};
